import React from 'react';

const StudentComplian = () => {
    return (
        <div className="container mt-4">
            <h2>Student Complaints</h2>
            {/* Add your complaint content here */}
        </div>
    );
};

export default StudentComplian; 